import { CommandProps } from '@tiptap/core';
import { TextSelection } from '@tiptap/pm/state';

import { sectionManagerKey, TSectionMeta } from '../SectionNode';

/**
 * Delete the entire section including its content.
 */
const deleteSectionCommand =
  (pos: number) =>
  ({ state, tr, dispatch }: CommandProps) => {
    const node = state.doc.nodeAt(pos);
    if (node?.type.name !== 'section') return false;

    if (dispatch) {
      // Set delta meta for O(1) section count update
      tr.setMeta(sectionManagerKey, { delta: -1 } as TSectionMeta);
      tr.delete(pos, pos + node.nodeSize);
      // Place cursor at the position where section was (or nearest valid position)
      const resolvedPos = tr.doc.resolve(Math.min(pos, tr.doc.content.size - 1));
      tr.setSelection(TextSelection.near(resolvedPos));
      dispatch(tr);
    }
    return true;
  };

export default deleteSectionCommand;
